import { Scope, createScope, animate, createSpring, createDraggable } from "animejs";
import { Box, Text } from "grommet";
import * as React from "react";
import { useNavigate } from "react-router-dom";

interface MenuItemProps {
    label: string;
    icon: string;
    path: string;
    [key: string]: any; // Allow other props to be passed to the Button component
}

const MenuItem = ({ label, icon, path, ...props }: MenuItemProps) => {
    const root = React.useRef(null);
    const scope = React.useRef<Scope | null>(null);

    // const [rotations, setRotations] = useState(0);

    React.useEffect(() => {
        if (scope) {
            scope.current = createScope({ root }).add((self) => {
                // Every anime.js instances declared here are now scopped to <div ref={root}>

                // Created a bounce animation loop
                animate(".menu-item", {
                    scale: [
                        { to: 1.1, ease: "inOut(3)", duration: 200 },
                        { to: 1, ease: createSpring({ stiffness: 300 }) },
                    ],
                });

                // Make the logo draggable around its center
                // createDraggable(".item", {
                //     container: [0, 0, 0, 0],
                //     releaseEase: createSpring({ stiffness: 300 }),
                // });

                // createDraggable(".menu-item", {
                //     container: [0, 0, 0, 0],
                //     releaseEase: createSpring({ stiffness: 300 }),
                // });
            });
        }
        // Properly cleanup all anime.js instances declared inside the scope
        return () => scope?.current?.revert();
    }, [scope]);

    const navigate = useNavigate();

    return (
        <div ref={root}>
            <Box className="menu-item" round="medium" pad="small" background="brand" {...props} width={"150px"} height="150px" align="center" justify="evenly" onClick={() => navigate(path)}>
                {/* <img src={icon} className="item" alt={`${label} icon`} style={{ width: "100px", height: "100px" }} /> */}
                <Text textAlign="center" color={"white"} weight={"bold"}>
                    {label}
                </Text>
            </Box>
        </div>
    );
};

export default MenuItem;
